import { Controller } from "@hotwired/stimulus"

// Auto-submits the parent <form> whenever any element matching the
// `submitter` target changes. Usage:
//
//   <form data-controller="auto-submit">
//     <select data-auto-submit-target="submitter">…</select>
//   </form>
export default class extends Controller {
  static targets = ["submitter"]

  submit() {
    this.element.requestSubmit()
  }

  connect() {
    this.submitterTargets.forEach(el => {
      el.addEventListener("change", () => this.submit())
    })
  }
}
